import React from 'react';
import { Modal, withPortal } from 'jd-library';
import SwipeableDrawer from 'jd-library/SwipeableDrawer';
import ProductAIChatbot from './ProductAIChatbot';

const AIAssistantModal = ({ isMobile, onHidden, onImagesConfirm, bizTypeRequired, ...chatbotProps }) => {
    if (isMobile) {
        return (
            <SwipeableDrawer onHidden={onHidden}>
                <ProductAIChatbot {...chatbotProps} bizTypeRequired={bizTypeRequired} onImagesConfirm={onImagesConfirm} onClose={onHidden} />
            </SwipeableDrawer>
        );
    }
    return (
        <Modal
            settings={{ modalId: 'ai-product-chatbot', variant: 'action ai-chatbot-modal' }}
            onHidden={onHidden}
        >
            <Modal.CloseIcon iconClass="icon-HDRcross" />
            <ProductAIChatbot {...chatbotProps} bizTypeRequired={bizTypeRequired} onImagesConfirm={onImagesConfirm} onClose={onHidden} />
        </Modal>
    );
};

export default withPortal(AIAssistantModal);
